
// Helper file to add commonly missing translations across all language files
export const commonTranslations = {
  compatible_cameras: {
    en: "Compatible Cameras",
    es: "Cámaras compatibles",
    fr: "Appareils compatibles",
    de: "Kompatible Kameras",
    zh: "兼容相机",
    ja: "互換性のあるカメラ",
    ko: "호환 카메라",
    pt: "Câmeras Compatíveis"
  },
  compatible_lenses: {
    en: "Compatible Lenses",
    es: "Lentes compatibles",
    fr: "Objectifs compatibles",
    de: "Kompatible Objektive",
    zh: "兼容镜头",
    ja: "互換性のあるレンズ",
    ko: "호환 렌즈",
    pt: "Lentes Compatíveis"
  },
  compatible_films: {
    en: "Compatible Films",
    es: "Películas compatibles",
    fr: "Films compatibles",
    de: "Kompatible Filme",
    zh: "兼容胶片",
    ja: "互換性のあるフィルム",
    ko: "호환 필름",
    pt: "Filmes Compatíveis"
  },
  with: {
    en: "with",
    es: "con",
    fr: "avec",
    de: "mit",
    zh: "使用",
    ja: "を使用した",
    ko: "사용",
    pt: "com"
  },
  or: {
    en: "or",
    es: "o",
    fr: "ou",
    de: "oder",
    zh: "或",
    ja: "または",
    ko: "또는",
    pt: "ou"
  },
  mount: {
    en: "mount",
    es: "montura",
    fr: "monture",
    de: "Anschluss",
    zh: "接口",
    ja: "マウント",
    ko: "마운트",
    pt: "montagem"
  },
  format: {
    en: "format",
    es: "formato",
    fr: "format",
    de: "Format",
    zh: "格式",
    ja: "フォーマット",
    ko: "포맷",
    pt: "formato"
  },
  // Common airport names
  "London Heathrow Airport": {
    en: "London Heathrow Airport",
    es: "Aeropuerto de Londres Heathrow",
    fr: "Aéroport de Londres Heathrow",
    de: "Flughafen London Heathrow",
    zh: "伦敦希思罗机场",
    ko: "런던 히드로 공항",
    pt: "Aeroporto de Londres Heathrow"
  },
  "London, United Kingdom": {
    en: "London, United Kingdom",
    es: "Londres, Reino Unido",
    fr: "Londres, Royaume-Uni",
    de: "London, Vereinigtes Königreich",
    zh: "英国伦敦",
    ko: "영국 런던",
    pt: "Londres, Reino Unido"
  },
  "Keflavik International Airport": {
    en: "Keflavik International Airport",
    es: "Aeropuerto Internacional de Keflavík",
    fr: "Aéroport international de Keflavík",
    de: "Internationaler Flughafen Keflavík",
    zh: "凯夫拉维克国际机场",
    ko: "케플라비크 국제공항",
    pt: "Aeroporto Internacional de Keflavík"
  },
  "Reykjavik, Iceland": {
    en: "Reykjavik, Iceland",
    es: "Reikiavik, Islandia",
    fr: "Reykjavik, Islande",
    de: "Reykjavík, Island",
    zh: "冰岛雷克雅未克",
    ko: "아이슬란드 레이캬비크",
    pt: "Reykjavik, Islândia"
  },
  "Leonardo da Vinci International Airport": {
    en: "Leonardo da Vinci International Airport",
    es: "Aeropuerto Internacional Leonardo da Vinci",
    fr: "Aéroport international Léonard de Vinci",
    de: "Internationaler Flughafen Leonardo da Vinci",
    zh: "列奥纳多·达·芬奇国际机场",
    ko: "레오나르도 다빈치 국제공항",
    pt: "Aeroporto Internacional Leonardo da Vinci"
  },
  "Rome, Italy": {
    en: "Rome, Italy",
    es: "Roma, Italia",
    fr: "Rome, Italie",
    de: "Rom, Italien",
    zh: "意大利罗马",
    ko: "이탈리아 로마",
    pt: "Roma, Itália"
  },
  "Logan International Airport": {
    en: "Logan International Airport",
    es: "Aeropuerto Internacional Logan",
    fr: "Aéroport international Logan",
    de: "Internationaler Flughafen Logan",
    zh: "洛根国际机场",
    ko: "로건 국제공항",
    pt: "Aeroporto Internacional Logan"
  },
  "Boston, United States": {
    en: "Boston, United States",
    es: "Boston, Estados Unidos",
    fr: "Boston, États-Unis",
    de: "Boston, Vereinigte Staaten",
    zh: "美国波士顿",
    ko: "미국 보스턴",
    pt: "Boston, Estados Unidos"
  }
};
